<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'订单审批'}]" style="width:100%"/>
        <div class="h-piece">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2 name">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine neixiao">
                        <el-form label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine inputO">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-input v-model="orderProjectName" placeholder="未关联"
                                     readonly></el-input>
                            </el-form-item>
                            <el-form-item label="主合同编号" class="h-elformWrap-2 ">
                                <el-input v-model="orderMainContract" placeholder="未关联" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="分合同编号" class="h-elformWrap-2">
                                <el-input v-model="orderSubContract" placeholder="未关联" readonly></el-input>
                            </el-form-item>
                            <div class="h-pieceTitle2">
                                <h1>订单信息</h1>
                            </div>
                            <div class="h-pieceCon2">
                                <div class="h-formLine n-two">
                                    <el-form-item label="销售区域" class="h-elformWrap-2" style="margin-left:-2px">
                                        <brselect category="xiaoshou_quyu" :v="formInline.orderCategory"
                                            v-model="formInline.orderCategory" disabled
                                            
                                            ></brselect>
                                    </el-form-item>
                                    <el-form-item label="销售组织" class="h-elformWrap-2">
                                        <brselect  category="xiaoshou_zuzhi" :v="formInline.saleGroupCode"
                                            v-model="formInline.saleGroupCode" disabled
                                        ></brselect>
                                    </el-form-item>
                                    <el-form-item label="分销渠道" class="h-elformWrap-2">
                                        <brselect  category="fenxiao_qudao"
                                            :v="formInline.disChannelCode"
                                            v-model="formInline.disChannelCode" disabled
                                            ></brselect>
                                    </el-form-item>
                                    <el-form-item label="二级分销渠道" class="h-elformWrap-2" v-if="yincang">
                                        <brselect category="z1_xuanxiang" :v="formInline.zCode"
                                            v-model="formInline.zCode" disabled
                                            ></brselect>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="h-pieceTitle2">
                                <h1>客户信息</h1>
                            </div>
                            <div class="h-pieceCon2">
                                <div class="h-formLine N-two">
                                    <el-form label-position="right" :inline="true"
                                             class="demo-ruleForm h-formbLine">
                                        <el-form-item prop="customerChannelCode" label="客户渠道"
                                                class="h-elformWrap-2"
                                                >
                                            <brselect clearable category="qu_dao" :v="formInline.customerChannelCode"
                                                v-model="formInline.customerChannelCode" disabled
                                                >
                                            </brselect>
                                        </el-form-item>
                                        <el-form-item prop="contactName" label="收货联系人" class="h-elformWrap-2">
                                            <el-input v-model="formInline.contactName" placeholder="请输入" readonly></el-input>
                                        </el-form-item>
                                        <el-form-item
                                                label="预计收货日期"
                                                class="h-elformWrap-2"
                                                width="120px"
                                                prop="receivedTime" >
                                            <div>
                                                <el-date-picker
                                                        v-model="formInline.receivedTime"
                                                        type="date"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="--选择--"
                                                        disabled>
                                                </el-date-picker>
                                            </div>
                                        </el-form-item>
                                        <el-form-item label="收货地址" class="h-elformWrap-2">
                                            <el-input v-model="formInline.toAddress" placeholder="请选择"  readonly ></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-table h-mrt30    bbbb">
            <div class="h-pieceTitle2 hang">
                <h1 class="h1">订单详情</h1>
            </div>
            <el-table
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                :data="tableData2"
                stripe
				border
                style="width: 100%">
                <el-table-column
                    fixed
                    type="index"
                    label="#"
                    width="40">
                </el-table-column>
                <el-table-column
                    prop="materialCode0"
                    label="产品编码"
					:show-overflow-tooltip="true"
                    >
                </el-table-column>
                <el-table-column
                    prop="proModelCode0"
                    label="产品型号"
					:show-overflow-tooltip="true"
                    >
                </el-table-column>
                <el-table-column
                    prop="proNumber0"
                    label="订单数量"
                    width="90">
                </el-table-column>
                <el-table-column
                    prop="proBenchmarkPrice0"
                    label="基准价"
                    width="90">
                </el-table-column>
                <el-table-column
                    prop="specialPrice"
                    label="特价"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="isStockUp"
                    label="是否备货"
                    width="120">
                    <template slot-scope="scope">
                        <dictname category="shifou_keyong"  :v="scope.row.isStockUp"/>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                    prop="spare3"-->
<!--                    label="定制需求"-->
<!--                    width="200">-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                    prop="extraPrice"-->
<!--                    label="定制加价"-->
<!--                    >-->
<!--                </el-table-column>-->
                <el-table-column
                    prop="finalPrice0"
                    label="成交价"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="totalPrice"
                    label="总价"
                    width="120">
                </el-table-column>
            </el-table>
        </div>
        <div class="jieguo">
            <span class="bizhong">币种</span>
            <span class="renminbi" style="width:2.3rem;">{{ currencyCode }}</span>
            <span class="dingdan">订单总价</span>
            <span class="yuan" style="width:2.3rem;">{{ allTotalPrice }}</span>
<!--            <span class="xianjin">现金余额</span>-->
<!--            <span class="money">{{ cashBalance }}</span>-->
            <span class="xianjin">现金占用</span>
            <span class="money" style="width:2.3rem;">{{ cashOccupy }}</span>
<!--            <span class="xianjin">信贷余额</span>-->
<!--            <span class="zhangqi">{{ creditBalance }}</span>-->
            <span class="xianjin">信贷占用</span>
            <span class="zhangqi" style="width:2.3rem;">{{ creditOccupy }}</span>
            <span class="jiazhi">净价值</span>
            <span class="make" style="width:2.3rem;">{{n.netPrice}}</span>
        </div>
        
        <div class="h-table h-mrt30    bbbb" v-if="clickActive==1">
            <div class="h-pieceTitle2 hang">
                <h1 class="h1">审批意见</h1>
                <el-form :model="formLabelAlign" label-position="right" :inline="true"
                         class="demo-ruleForm h-formbLine ">
                    <el-form-item label="审批意见" class="h-elformWrap-2 " :required="flaag"
                            style="margin:30px 0 20px 23px">
                        <el-input v-model="tableData.yijianMsg" placeholder="请输入"
                            ></el-input>
                    </el-form-item>
                </el-form>
                
            </div>
        </div>
        <div class="apprButton">
            <el-row>
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgred" @click="refuse">驳回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="pass">通过</el-button>
                <el-button class="h-btn h-bBtn" @click="findDetail">查看审批详情</el-button>
            </el-row>
        </div>
        <!--查看跟踪审批流组件： showhistory：打开流程框，instid：流程id-->
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>


<script>
    import ss from '../../api/SystemService'
    import big from 'big.js'

    export default {

      

        created() {
            this.q.orderId = this.$route.query.orderId || this.$route.query.ywid;
            this.queryMoney(this.q.orderId);
            this.q.taskid = this.$route.query.taskid;
            this.instid = this.$route.query.instid;
            this.query();

            // this.topChange();
        },
        mounted() {
        },

        methods: {

            //查看审批流详情
            findDetail(){
                this.showhistory = true;
            },


            //顶部审核状态改变
            topChange() {
                switch (this.tableData.orderStatus) {
                    case '20':
                        break;
                    case "24":
                        console.log('哈哈哈哈哈!');
                        this.showimg2 = true;
                        this.fuwu = true;
                        break;
                    default:
                        console.log("嘿嘿嘿嘿嘿!")
                        break;
                }
            },

            hidden(index) {
                if (index === 6) {
                    this.show = fasle;
                }
            },

            //查询余额
            queryMoney(x) {
                ss.OrderService.queryMoneyByOrderCode(x).then(rd => {
                    this.cashBalance = rd.obj.cashBalance;
                    this.creditBalance = rd.obj.creditBalance;
                });
            },
            //查询信贷
            getCredit() {
                this.params1.saleGroupCode = this.formInline.saleGroupCode;
                this.params1.orderProductList = this.tableData2;
                this.params1.orderProductList.forEach((item, index) => {
                    item.materialCode = item.materialCode0;
                })
                this.params1.usercode = this.tableData2[0].soldToCode;
                ss.OrderService.getCredit(this.params1).then(rd => {
                    this.creditData = rd;
                    console.log(this.creditData)
                })
            }
            ,

            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            query() {
                console.log('fq',this.q.orderId);
                ss.OrderService.getSingleOrderDetail(this.q).then(rd => {
                    this.tableData2 = rd;

                    console.log(this.tableData2)

                    this.orderProjectName = this.tableData2[0].orderProjectName;


                    this.orderMainContract = this.tableData2[0].orderMainContract;
                    this.orderSubContract = this.tableData2[0].orderSubContract;

                    this.formInline.zCode = this.tableData2[0].zCode;
                    this.formInline.saleGroupCode = this.tableData2[0].saleGroupCode;
                    this.formInline.orderCategory = this.tableData2[0].orderCategory;
                    this.formInline.orderCategory1 = this.tableData2[0].orderCategory1;
                    this.formInline.disChannelCode = this.tableData2[0].disChannelCode;
                    this.formInline.toAddress = this.tableData2[0].toAddress;
                    this.formInline.contactName = this.tableData2[0].contactName;
                    this.formInline.receivedTime = this.tableData2[0].receivedTime;
                    this.formInline.customerChannelCode = this.tableData2[0].customerChannelCode;
                    this.currencyCode = this.tableData2[0].currencyCode;
                    this.getCredit();

                    if (this.formInline.disChannelCode == 'Z1') {
                        this.yincang = true;
                    }
                    this.getETotalPrice(this.tableData2);

                });
                //this.tableData.orderStatus = 24;
            },


            //计算每行总价
            getETotalPrice(x) {
                x.forEach((item, index) => {
                    item.totalPrice = new big(item.proNumber0).times(item.finalPrice0).toString();
                })
                this.tableData2 = x;
                this.getAllTotalPrice(this.tableData2);
            },

            //总价总和改变
            getAllTotalPrice() {
                this.allTotalPrice = 0;
                var aaa = 0;
                var bbb = 0;
                this.tableData2.forEach(function (val, index) {
                    aaa = new big(aaa).plus(val.totalPrice);
                })
                big.DP = 2;
                bbb = new big(aaa).div(1.3);
                this.allTotalPrice = aaa.toString();
                this.n.netPrice = bbb.toString();
                this.showMeYourMoney();
            }
            ,
            //下单金额扣除
            showMeYourMoney() {
                this.cashOccupy = this.creditOccupy = 0;
                if (this.allTotalPrice <= this.cashBalance) {
                    //现金足够扣现金
                    this.cashOccupy = this.allTotalPrice;
                    //现金不足扣信贷
                } else if (this.allTotalPrice > this.cashBalance) {
                    //现金全部扣完
                    this.cashOccupy = this.cashBalance;
                    //剩余部分扣信贷
                    this.creditOccupy = this.allTotalPrice - this.cashBalance;
                }
            },

            //订单审核
            orderPass(x) {
                x.taskId = this.q.taskid;
                x.orderId = this.tableData2[0].oid;
                x.orderCategory1 = this.tableData2[0].orderCategory1;
                console.log('审核流程结果', x)
                ss.OrderService.orderPass(x).then(rd => {
                });
                this.$router.push({path: '/thirdPage', query: {id: ''}});
            },

            //通过按钮
            pass() {
                this.tableData.isPass = 2
                this.tableData.optflag = '审核通过';
                this.orderPass(this.tableData);
                this.$router.push({path: '/personal/dealCenter'});
            },

            //驳回按钮
            refuse() {
                if (this.tableData.yijianMsg == '') {
                    this.$msg.msge('驳回必须输入审批意见!');
                } else {
                    this.tableData.isPass = 1
                    this.tableData.optflag = '审核被驳回';
                    this.orderPass(this.tableData);
                    this.$router.push({path: '/personal/dealCenter'});
                }
            },

            //取消按钮
            cancel() {
                //返回首页
                this.$router.push({path: '/personal/dealCenter'});
            },
        },
        data() {
            return {

                params1: {
                    orderProductList: [],
                    saleGroupCode: '',
                    usercode: null,
                },

                //审批流程开关
                showimg1: false,
                showimg2: false,
                showimg3: false,
                Dcolor: false,
                Fcolor: false,
                color: false,
                shouhou: false,
                fuwu: false,
                fukuan: false,
                
                isAA: true,
                isC: true,
                isB: true,
                isA: true,
                
                instid: '',
                showhistory: false,
                //订单审核相关数据
                tableData: {
                    orderCategory1: '',
                    orderStatus: '',
                    orderId: '',
                    optflag: '',
                    yijianMsg: '',
                    isPass: '',
                    taskId: '',
                },

                yincang: false,

                orderProjectName: '',
                orderMainContract: '',
                orderSubContract: '',

                flaag: true,
                n: {
                    netPrice: '',
                    quota: '',
                    id: '',
                    paymentdate: '',
                },
                //表单
                q: {
                    taskid: null,
                    orderId: '',
                },

                //现金及信贷
                cashBalance: 0,
                cashOccupy: 0,
                creditBalance: 0,
                creditOccupy: 0,
                allTotalPrice: 0,
                currencyCode: '',

                //审批意见
                approOpinion: '',
                //审批提示信息
                tishixinxi: '',
                yijianbixutian: false,
                tejiashenpi: {

                    shenheyijian: '',

                },
                show: true,

                formInline: {
                    orderProjectName: '',
                    saleGroupCode: '',
                    orderCategory: '',
                    orderCategory1: '',
                    disChannelCode: '',
                    zCode: '',
                },
                message: '',
                value1: '',
                multipleSelection: [],
                tableData2: [],
                clickActive: 1,
                formLabelAlign: {},

            };
        },
    }

</script>


<style scoped>

    .N-two{
        margin-left: -13px;
    }
    .n-two{
        margin-left: -10px;
    }
    .apprButton {
        margin-left: 5rem;
        margin-top: 30px;
    }
    .cancel {
        padding: 0.18rem 0.42rem;
    }

    .pass {
        background-color: #006aca;
        color: white;
        padding: 0.18rem 0.42rem;
    }

    .refuse {
        background-color: #24b5b8;
        color: white;
        padding: 0.18rem 0.42rem;
    }

    /*--------------- 审批样式 ------------------*/
    .name {
        margin-left: 9px;
    }
    .make {
        width: 110px;
        padding-left: 17px;
    }
    .jiazhi {
        width: 100px;
        padding-left: 20px;
    }
    .zhangqi {
        width: 168px;
        padding-left: 10px;
    }
    .yuan, .zhanyong, .money, .xianjin, .dingdan {
        width: 120px;
        padding-left: 20px;
    }
    .renminbi {
        width: 90px;
        padding-left: 20px;
    }
    .bizhong {
        width: 72px;
        padding-left: 20px;

    }
    .renminbi,
    .money,
    .yuan,
    .zhangqi,
    .make {
        background-color: white;
        font-size: 10px;
    }
    .bizhong,
    .dingdan,
    .xianjin,
    .zhanyong,
    .jiazhi {
        background-color: #ebf5ff;
        font-size: 10px;
    }
    .bizhong,
    .renminbi,
    .dingdan,
    .money,
    .xianjin,
    .yuan,
    .zhangqi,
    .zhanyong,
    .jiazhi,
    .make {
        font-size: 15px;
        color: black;
        padding: 20px 0;
        padding-left: 18px;
        border-bottom: 1px solid rgb(223, 222, 222);
        border-right: 1px solid rgb(236, 236, 236);
    }
    .jieguo {
        margin-top: 12px;
        display: flex;
        margin: 0 20px;
    }
    .h-crumbOut {
        margin-bottom: 20px;
    }
    .h-piece {
        margin: 20px;
    }
    .h1 {
        margin-left: 27px;
    }
    .bbbb {
        padding-top: 5px;
        margin: 10px 20px 0 20px;
    }
    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
</style>
<style>

    .neixiao .h-formbLine .h-elformWrap-2{
        width: 33%;
    }
    .neixiao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .neixiao .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .neixiao .h-formbLine .el-form-item__content .el-select{
        width:100% !important;
    }
</style>